module.exports = __webpack_public_path__ + "img/katarina_bathrooms_5.db64d776.jpg";